module.exports = __webpack_public_path__ + "static/concept_bg_img_sp-2de94f718032b7a88480ab26398f0ba4.png";